import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section } from './Shared';
type Testimonial = {
  initials: string;
  name: string;
  location: string;
  role: string;
  text: string;
};
function TestimonialCard({
  initials,
  name,
  location,
  role,
  text
}: Testimonial) {
  return <article className="glass-panel flex h-full flex-col rounded-2xl p-6 pt-[20px] pb-[20px] pl-[20px] pr-[20px]" data-id="element-280" data-mp="3b0ucrixfp1wg">
      <div className="mb-4 flex items-center gap-3" data-id="element-281" data-mp="36z95qe7kzhu6">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-brand-yellow/60 bg-brand-surfaceLight font-serif font-bold text-brand-green" data-id="element-282" data-mp="36wwiblj20f9q">
          {initials}
        </div>
        <div data-id="element-283" data-mp="2s1qaqu4b88ea">
          <div className="mb-1 flex text-brand-yellow" data-id="element-284" data-mp="2s28cu7dnlgu4">
            {Array.from({
            length: 5
          }, (_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-current" data-id="element-285" data-mp="v8dkrjstq8bc" />)}
          </div>
          <h3 className="text-sm font-bold text-brand-dark" data-id="element-286" data-mp="qa3rjeqnthsd">
            {name}{' '}
            <span className="font-normal text-brand-muted" data-id="element-287" data-mp="h5f0vqsro53b">— {location}</span>
          </h3>
          <p className="text-xs text-brand-green" data-id="element-288" data-mp="m4rnqbjn1c5w">{role}</p>
        </div>
      </div>
      <blockquote className="font-serif italic text-brand-text text-[14px]" data-id="element-289" data-mp="m2opj48c0cq3">
        “{text}”
      </blockquote>
    </article>;
}
const first: Testimonial[] = [{
  initials: 'MG',
  name: 'Marcela G.',
  location: 'Córdoba',
  role: 'Terapeuta Corporal',
  text: 'Este sistema me dio el marco teórico y las herramientas prácticas para abordar la salud hepática con criterio y seguridad en cada sesión.'
}, {
  initials: 'JL',
  name: 'Jorge L.',
  location: 'Buenos Aires',
  role: 'Naturópata',
  text: 'El Botiquín Herbolario es la guía más completa sobre plantas nativas que encontré. La uso como material de consulta permanente.'
}, {
  initials: 'CP',
  name: 'Carolina P.',
  location: 'La Plata',
  role: 'Terapeuta Holística',
  text: 'El módulo del hígado emocional cambió mi forma de trabajar. Entender la conexión entre la ira contenida y los síntomas físicos fue un antes y un después.'
}];
const more: Testimonial[] = [{
  initials: 'AV',
  name: 'Ana V.',
  location: 'Mendoza',
  role: 'Terapeuta Floral',
  text: 'Las fichas del Botiquín Herbolario las tengo en el consultorio. Mis pacientes las llevan a casa y vuelven con preguntas mucho más específicas.'
}, {
  initials: 'SB',
  name: 'Sofía B.',
  location: 'CABA',
  role: 'Terapeuta Transpersonal',
  text: 'El módulo emocional me dio el lenguaje que me faltaba para hablar del hígado sin salirme de mi enfoque.'
}, {
  initials: 'ML',
  name: 'Marta L.',
  location: 'Rosario',
  role: 'Masajista Terapéutica',
  text: 'La guía de semiología visual es oro puro. Aprender a leer la lengua y los ojos de mis pacientes cambió completamente mis consultas.'
}, {
  initials: 'VR',
  name: 'Valeria R.',
  location: 'Neuquén',
  role: 'Terapeuta Bioenergética',
  text: 'La hoja de ruta de 21 días es lo que mis pacientes necesitaban. Ahora vuelven con avances reales entre sesiones.'
}];
export function InitialTestimonials() {
  return <Section className="pt-9 md:pt-12" data-id="element-290" data-mp="37g0eh98zog4c">
      <h2 className="mb-8 text-center font-display text-3xl font-bold text-brand-dark md:text-4xl" data-id="element-291" data-mp="37expj6v88nr2">
        Lo que dicen los terapeutas que ya lo usan
      </h2>
      <div className="grid grid-cols-1 gap-5 md:grid-cols-3" data-id="element-292" data-mp="3ggorc0mncafn">
        {first.map(item => <TestimonialCard key={item.initials} {...item} data-id="element-293" data-mp="3gekolm0hhhgy" />)}
      </div>
    </Section>;
}
export function MoreTestimonials() {
  return <Section data-id="element-294" data-mp="2op96oc4ngxs2">
      <h2 className="mb-10 text-center font-display text-3xl font-bold text-brand-dark md:text-4xl" data-id="element-295" data-mp="2oops95e7kris">
        Más terapeutas que ya lo usan
      </h2>
      <div className="mx-auto grid max-w-4xl grid-cols-1 gap-5 md:grid-cols-2" data-id="element-296" data-mp="2sozxgfu6fdwl">
        {more.map(item => <TestimonialCard key={item.initials} {...item} data-id="element-297" data-mp="2xjxfgc9foxlm" />)}
      </div>
    </Section>;
}